import { useEffect, useRef, useState, Fragment } from 'react'
import { useNavigate } from 'react-router-dom'
import { IconSlash, IconArrowLeft } from '@tabler/icons-react'
import Text from '@fragments/Text'
import Button from '@fragments/Button'
import { useScreen } from '../ScreenContext'
import './styles.scss'

export default function Breadcrumb() {
    const { breadcrumb } = useScreen()
    const navigate = useNavigate()
    const rootRef = useRef(null)


    if (!breadcrumb?.length) return null

    const handleBack = () => {
        if (breadcrumb.length > 1 && breadcrumb[breadcrumb.length - 2]?.href) {
            navigate(breadcrumb[breadcrumb.length - 2].href)
        } else {
            navigate(-1)
        }
    }

    return (
        <div
            ref={rootRef}
            className={`cs-breadcrumb`}
        >
            <Button
                icon={<IconArrowLeft />}
                color="overlay"
                size="micro"
                variant="rounded"
                onClick={handleBack}
                aria-label="Voltar"
                preventLoading
            />
            <div className="cs-breadcrumb-items">
                {breadcrumb.map((item, index) => {
                    const isLast = index === breadcrumb.length - 1
                    return (
                        <Fragment key={index}>
                            {index > 0 && (
                                <IconSlash className="cs-breadcrumb-separator" size={16} />
                            )}
                            <div
                                className={`cs-breadcrumb-item${!isLast && item.href ? ' cs-breadcrumb-item--link' : ''}`}
                                onClick={() => !isLast && item.href && navigate(item.href)}
                            >
                                {item.icon && (
                                    <span className="cs-breadcrumb-icon">{item.icon}</span>
                                )}
                                <Text.h5 weight={400} contrast={7}>
                                    {item.label}
                                </Text.h5>
                            </div>
                        </Fragment>
                    )
                })}
            </div>
        </div>
    )
}
